import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import {
  LandingPage,
  OnboardingPage,
  CallbackPage,
  Dashboard,
  AnalysisDetailPage,
  CompaniesPage,
  CompanyDetailsPage,
  NotificationsPage,
  SettingsPage,
  ProfilePage,
  SubscriptionPage,
  ManageSubscriptionPage,
  SyncSubscriptionPage,
  PrivacyPolicyPage,
  TermsOfUsePage,
} from './pages';
import MainLayout from './layouts/MainLayout';
import { useUserData } from './hooks/useUserData';
import { getUserPlan } from './utils/userPlan';

const RequireActivePlan: React.FC = () => {
  const { isLoading, isAuthenticated, user } = useUserData();
  const userPlan = user ? getUserPlan(user.groups) : null;

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="w-10 h-10 border-4 border-gray-200 border-t-blue-700 rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (!userPlan) {
    return <Navigate to="/assinatura" replace />;
  }

  return <Outlet />;
};

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Rotas Públicas */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/politica-de-privacidade" element={<PrivacyPolicyPage />} />
          <Route path="/termos-de-uso" element={<TermsOfUsePage />} />
          <Route path="/onboarding" element={<OnboardingPage />} />
          <Route path="/callback" element={<CallbackPage />} />
          <Route path="/assinatura/sincronizar" element={<SyncSubscriptionPage />} />

          {/* Rotas Protegidas com Layout Principal */}
          <Route element={<MainLayout />}>
            <Route element={<RequireActivePlan />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/dashboard/analise/:analysisId" element={<AnalysisDetailPage />} />
              <Route path="/empresas" element={<CompaniesPage />} />
              <Route path="/empresas/:ticker" element={<CompanyDetailsPage />} />
              <Route path="/configuracoes" element={<SettingsPage />} />
            </Route>
            <Route path="/notificacoes" element={<NotificationsPage />} />
            <Route path="/perfil" element={<ProfilePage />} />
            <Route path="/assinatura" element={<SubscriptionPage />} />
            <Route path="/assinatura/gerenciar" element={<ManageSubscriptionPage />} />
          </Route>
          
          {/* Redirecionamento para rotas não encontradas */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;


